import { render } from "./EditPRAttachment.vue?vue&type=template&id=3800d34e"
import script from "./EditPRAttachment.vue?vue&type=script&lang=js"
export * from "./EditPRAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__